export enum ReferenceDocumentation {
  PRODUCT_GUIDE_FR = 'guide-de-produit.pdf',
  PRODUCT_GUIDE_EN = 'product-guide.pdf',
  UNDERWRITING_GUIDE_FR = 'guide-de-tarification.pdf',
  UNDERWRITING_GUIDE_EN = 'underwriting-guide.pdf',
}

export const HUMANIA_FORMS_FR =
  'https://www.humania.ca/individuelle/reclamations-formulaires/modifier-police';
export const HUMANIA_FORMS_EN = 'https://www.humania.ca/en-CA/individual/claims-forms/change-policy';
